<template>
  <div class=" ksapcxDetail">
    <Header title="考试安排查询详情"></Header>
    <h4>{{ list.KCMC }}[{{ list.KCH }}]</h4>
    <p>
      校区 ： <b> {{ list.XQMC }}</b>
    </p>
    <p>
      考试场次： <b> {{ list.KSCCMC }}</b>
    </p>
    <p>
      授课教师： <b> {{ list.JSXM }}</b>
    </p>
    <p>
      考试时间： <b> {{ list.KSSJ }}</b>
    </p>
    <p>
      考场： <b> {{ list.KSCDMC }}</b>
    </p>
    <p>
      考生数： <b> {{ list.KCZRS }}</b>
    </p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: []
    };
  },
  created() {
    this.list = this.$route.query.list;
  }
};
</script>
<style lang="less" scoped>
.ksapcxDetail {
  padding: 20px;
}
.ksapcxDetail h4 {
  color: @attendance-color-1;
  font-size: 18px;
  line-height: 25px;
  margin-bottom: 8px;
}
.ksapcxDetail p {
  color: @attendance-color-2;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 8px;
}
.ksapcxDetail .bottom-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;
  padding: 0 5% 10px;
  background: #fff;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;

  button {
    display: block;
    height: 100%;
    width: 47.5%;
    background: #7469f8;
    border-radius: 3px;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/ksapcx/detail.vue